import { render, staticRenderFns } from "./reviewResult.vue?vue&type=template&id=29dac893&scoped=true&"
import script from "./reviewResult.vue?vue&type=script&lang=js&"
export * from "./reviewResult.vue?vue&type=script&lang=js&"
import style0 from "./reviewResult.vue?vue&type=style&index=0&id=29dac893&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dac893",
  null
  
)

component.options.__file = "reviewResult.vue"
export default component.exports